import { IconProps } from "@assets";

const PlayButton = ({ ...props }: IconProps): JSX.Element => {
    return (
        <svg
            width={props.size ?? "48"}
            height={props.size ?? "48"}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="24" cy="24" r="24" fill="#F0F7FA" />
            <path
                d="M35.915 22.1741C37.4935 22.8797 37.4935 25.1204 35.915 25.8259L19.5661 33.1335C18.2431 33.7249 16.75 32.7568 16.75 31.3076L16.75 16.6924C16.75 15.2432 18.2431 14.2751 19.5661 14.8665L35.915 22.1741Z"
                fill="#3266A8"
            />
        </svg>
    );
};

export default PlayButton;
